<template>
  <div>
    <hg-dialog :title="'行为日志详情'" :height="450" :width="880" :visible="dialogVisible" @close="handleClose">
      <div style="height:calc(100% - 40px);">
        <my-content ref="ref" :form-data.sync="formData" />
      </div>

      <div slot="footer" style="width:100%;text-align: right">
        <div>
          <el-button size="small" icon="el-hg-icon-close" type="danger" @click="handleClose">关 闭</el-button>
        </div>
      </div>
    </hg-dialog>
  </div>
</template>

<script>
import HgDialog from '@/components/dialog';
import MyContent from './content';

export default {
  name: 'insert',
  components: {
    MyContent,
    HgDialog
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  props: {
    formData: { type: Object },
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$emit('close');
    }
  },
  // dialog show
  watch: {
    show(val) {
      if (val) {
        this.dialogVisible = true;
      }
      else {
        this.dialogVisible = false;
      }
    }
  }
}
</script>